
export class SummaryFormPdf  {
    BusinessName:string = ""
    FormId:string = ""
    TaxYear:string = ""
    EIN:string = ""
    TINTypes:string = "EIN"
  }